/*import React, { createContext, useContext, useState } from "react";

const AccountsContext = createContext();

export const AccountsProvider = ({ children }) => {
  const [accounts, setAccounts] = useState([]);

  return (
    <AccountsContext.Provider value={{ accounts, setAccounts }}>
      {children}
    </AccountsContext.Provider>
  );
};

export const useAccounts = () => useContext(AccountsContext);*/

//Trial-1

import { createContext, useContext, useState, useEffect } from "react";

export const AccountsContext = createContext();

export const AccountsProvider = ({ children }) => {
  const [accounts, setAccounts] = useState(() => {
    try {
      const saved = localStorage.getItem("ct_accounts");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("ct_accounts", JSON.stringify(accounts));
  }, [accounts]);

  return (
    <AccountsContext.Provider value={{ accounts, setAccounts }}>
      {children}
    </AccountsContext.Provider>
  );
};

// ✅ ADD THIS (THIS FIXES YOUR ERROR)
export const useAccounts = () => {
  return useContext(AccountsContext);
};